import type { FC, ReactNode, JSX } from 'react';

interface MetricCardProps {
    icon: ReactNode;
    label: string;
    value: string;
    subtext: string;
    color: string;
}

const MetricCard: FC<MetricCardProps> = ({ 
    icon, 
    label, 
    value, 
    subtext, 
    color 
}): JSX.Element => {
     return (
        <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
        <div className="flex items-center justify-between mb-2">
            <div className={`p-2 bg-${color}-100 rounded-lg`}>
            {icon}
            </div>
        </div>
        <p className="text-2xl font-bold text-gray-900 mb-1">{value}</p>
        <p className="text-sm font-medium text-gray-700">{label}</p>
        <p className="text-xs text-gray-500 mt-1">{subtext}</p>
        </div>
  );
};

export default MetricCard;